import React, { Component } from "react";
import { withTranslation } from 'react-i18next';

class Weeklylive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawtype: props.drawtype,
            _dbdrawType: props.send_db_id
        }
    }

    componentDidMount() {
        window.allDrawResultPopUp();
        localStorage.setItem('drawtabId', 4);
    }

    setUrl = () => {
        window.open("https://www.youtube.com/@Gulfticket/streams", "_blank");
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div class="myAccContHead border-none">
                    <h1><img src="./assets/img/icons/tabs-Weekly-Live-Stream.png" />{t('lblWeeklyLive')}</h1>
                </div>
                <div class="weeklyLiveStream">
                    <div class="wklyLiveStmLft" onClick={() => { this.setUrl() }}>
                        {this.state.drawtype == 1 ? <img src="./assets/img/past-draws/wls-1.png?v0.2" alt="Fortune4"  />
                            : this.state.drawtype == 2 ? <img src="./assets/img/past-draws/wls-2.png?v0.1" alt="super6"  />
                                : this.state.drawtype == 3 ? <img src="./assets/img/past-draws/wls-3.png" alt="lucky-1"  />
                                    : this.state.drawtype == 4 ? <img src="./assets/img/past-draws/wls-4.png" alt="dream-5"  />
                                        : this.state.drawtype == 5 ? <img src="./assets/img/past-draws/wls-5.png?v0.1" alt="dream-5"  />
                                            : <img src="./assets/img/past-draws/wls-6.png?v0.1" alt="magic"  />}
                    </div>
                    <div class="wklyLiveStmRht">
                        {this.state.drawtype == 1 ? <p>{t('lblWatchlivefortune5')}</p>
                            : this.state.drawtype == 2 ? <p>{t('lblWatchlivesuper6')}</p>
                                : this.state.drawtype == 3 ? <p>{t('lblWatchlivelucky1')}</p>
                                    : this.state.drawtype == 4 ? <p>{t('lblWatchlivedream5')}</p>
                                        : this.state.drawtype == 5 ? <p>{t('lblmultimillion')}</p>
                                            : <p>{t('lblWatchlivemagic5')}</p>}
                        <div>
                            <a href="https://www.youtube.com/@Gulfticket/streams" target="_blank" rel="noopener"><img src="./assets/img/icons/youtube-y.png" /><span>Youtube</span></a>
                            <a href="https://www.facebook.com/gulfticketindia" target="_blank" rel="noopener"> <img src="./assets/img/icons/facebook-y.png" /><span>Facebook</span></a>
                        </div>
                    </div>
                </div>

            </>

        )
    }
}




export default (withTranslation()(Weeklylive))
